<template>
  <footer class="footer">
      <div class="copyright">
        &copy; Breaze Delivery
      </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>

</style>
